import {
  useOnboardingFeatureEnabled,
  type OnboardingFeatureEnabledResult,
} from "../../onboarding/hooks/useOnboardingFeatureEnabled";
import { FeatureFlag } from "../../feature-flags";

export type SplitCostingImportEnabledResult = OnboardingFeatureEnabledResult;

/**
 * Composite gate for the split costing import feature.
 *
 * The route is visible only when:
 *  1. `enable-onboarding` is on (the parent OnboardingLayout already gates
 *     the entire subtree, but the layout needs this independently for the
 *     sidebar link and its own guard — both flags evaluated here).
 *  2. `enable-split-costing-import` is on.
 *
 * Access is flag-only — same posture as Pay Component Import and Work Pattern
 * Import. There is no `AgenticProvisioner` role check.
 *
 * `isLoaded` prevents a redirect flash: the layout renders nothing until both
 * flags are present in the LD payload, mirroring `useOnboardingEnabled`.
 */
export function useSplitCostingImportEnabled(): SplitCostingImportEnabledResult {
  return useOnboardingFeatureEnabled(FeatureFlag.EnableSplitCostingImport);
}
